<template>
  <div class="container page">
    <van-nav-bar class="nav-bar" :title="$t('绑定银行卡')">
      <template #left>
        <van-icon color="#fff" name="arrow-left" @click="handleBack"/>
      </template>
    </van-nav-bar>
    <div class="main-box">
      <van-field
          v-model="activeWithdrawType"
          :label="$t('取款方式')"
          :placeholder="$t('请选择{name}',{name: $t('取款方式')})"
          readonly
          @click="showWithdrawType=true"
          right-icon="arrow"
      />

      <van-cell-group v-if="activeWithdrawType === $t('银行卡')">
        <van-field v-model="form.bankName" :label="$t('银行名称')"
                   :placeholder="$t('请输入{name}',{name: $t('银行名称')})"/>
        <van-field v-model="form.owner" :label="$t('姓名')" :placeholder="$t('请输入{name}',{name: $t('姓名')})"/>
        <van-field v-model="form.account" :label="$t('银行账户号码')"
                   :placeholder="$t('请输入{name}',{name: $t('银行账户号码')})"/>
      </van-cell-group>

      <van-cell-group v-if="activeWithdrawType === $t('虚拟币')">
        <van-field v-model="form.bankName"
                   @click="showCoinType=true"
                   right-icon="arrow"
                   readonly
                   :label="$t('选择{name}',{name: $t('币种')})" :placeholder="$t('请选择{name}',{name: $t('币种')})"/>
        <van-field v-model="form.account" :label="$t('地址')" :placeholder="$t('请输入{name}',{name: $t('地址')})"/>
      </van-cell-group>
      <p>{{
          $t('尊敬的用户,为了保障您的资金安全,请您绑定您的真实姓名和设置取款密码,如果姓名与开户名不一致,将无法取款')
        }}</p>
    </div>
    <van-button class="bindCard" type="default" @click="bindCard()">{{ $t('确认绑定') }}</van-button>

    <!--选择提款方式-->
    <van-popup v-model="showWithdrawType" :style="{ height: '35%' }" position="bottom" round>
      <van-picker
          :columns="withdrawType"
          show-toolbar
          @cancel="showWithdrawType=false"
          @confirm="onSelectTypeConfirm"
      />
    </van-popup>
    <!--选择币种类型-->
    <van-popup v-model="showCoinType" :style="{ height: '35%' }" position="bottom" round>
      <van-picker
          :columns="coinType"
          show-toolbar
          @cancel="showCoinType=false"
          @confirm="onSelectCoinConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showCoinType: false,
      showWithdrawType: false,
      isBankFull: false,
      isCryptoFull: false,
      activeWithdrawType: '',
      form: {
        bankName: '',
        owner: '',
        account: '',
        routeCode: '',
        swiftCode: '',
      },
    };
  },
  computed: {
    withdrawType() {
      return [{text: this.$t('银行卡'), disabled: this.isBankFull}, {text: this.$t('虚拟币'), disabled: this.isCryptoFull}]
    },
    coinType() {
      return ['USDT', 'ETH', 'BTC']
    },
  },
  methods: {
    validate() {
      if (this.activeWithdrawType === this.$t('银行卡')) {
        if (!this.form.bankName) {
          this.$toast.fail(this.$t("请输入{name}", {name: this.$t('银行名称')}) + "！");
          return false;
        }
        if (!this.form.owner) {
          this.$toast.fail(this.$t("请输入{name}", {name: this.$t('姓名')}) + "！");
          return false;
        }
        if (!this.form.account) {
          this.$toast.fail(this.$t("请输入{name}", {name: this.$t('银行账户号码')}) + "！");
          return false;
        }
        return true;
      } else {
        if (!this.form.bankName) {
          this.$toast.fail(this.$t("请选择{name}", {name: this.$t('币种')}) + "！");
          return false
        }
        if (!this.form.account) {
          this.$toast.fail(this.$t("请输入{name}", {name: this.$t('地址')}) + "！");
          return false;
        }
        return true
      }

    },
    bindCard() {
      if (!this.validate()) {
        return
      }
      this.$http({
        method: 'post',
        data: this.form,
        url: 'user_set_bank'
      }).then(res => {
        if (res.code === 200) {
          this.$router.back()
          this.$toast(res.msg);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    onSelectCoinConfirm(value) {
      this.form.bankName = value
      this.showCoinType = false;
    },
    onSelectTypeConfirm(value) {
      value = value.text
      this.activeWithdrawType = value
      if (value === this.$t('虚拟币')) {
        this.form.bankName = this.coinType[0];
        console.log("=>(BindCard.vue:139) this.coinType", this.coinType);
      } else {
        this.form.bankName = '';
      }
      this.form.account = ''
      this.showWithdrawType = false;
    },
    getBankList() {
      return new Promise((resolve, reject) => {
        this.$http({
          method: 'get',
          url: 'userBankList'
        }).then(res => {
          if (res.code === 200) {
            console.log(res.data)
            this.bankInfoList = res.data

            const cryptoList = ['USDT','ETH','BTC']
            // 判断数组的x属性是否包含至少一个cryptoList的元素和至少一个不是cryptoList的元素
            this.isCryptoFull = this.bankInfoList.some(item => cryptoList.includes(item.bankName))
            this.isBankFull = this.bankInfoList.some(item => !cryptoList.includes(item.bankName))

            if (this.isBankFull && this.isCryptoFull) {
              this.$toast(this.$t('绑定上限，请联系客服!'));
              this.$router.back();
              return;
            }

            this.activeWithdrawType = this.isBankFull ? this.withdrawType[1].text : this.withdrawType[0].text;

            resolve()
          } else if (res.code === 401) {
            this.$toast(res.msg);
            reject()
          }
        })
      })
    },
    handleBack() {
      console.log("=>(BindCard.vue:99) this.bankInfoList", this.$route.query)
      const from = (this.$route.query.from || '/Mine') + '?from=BindCard'
      this.$router.replace(from)
    }
  },
  async created() {


    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    } else {
      await this.getBankList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.container {
  padding-bottom: 200px;
  min-height: 100%;
  height: auto !important;
}

.van-cell {
  font-size: 32px;
  line-height: 80px;
  display: block;
}

::v-deep .van-field__label {
  width: fit-content;
}

.van-hairline--bottom::after {
  border-bottom-width: 3px;
}

.bankbox {
  padding: 15px;
  color: #000;
  background-color: #fff;
}

.bankbox .title {
  padding: 8px 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
}

.main-box {
  padding: 0 8px;
  background: #fff;

}

.main-box .label {
  padding: 20px;
  font-size: 35px;
  color: #797878;
}

::v-deep .van-picker__toolbar {
  height: 50px;
}

::v-deep .van-picker__cancel, .van-picker__confirm {
  padding: 0 20px;
  font-size: 20px;
}

::v-deep .van-picker-column {
  font-size: 40px;
}

.main-box p {
  padding: 0 20px;
  font-size: 30px;
  color: #ee0a24;
}

.bindCard {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(90deg, #e6c3a1, #7e5678);
}

::v-deep .van-icon-arrow {
  font-size: 30px !important;
}

::v-deep .van-cell__title {
  font-size: 30px !important;
}

::v-deep .van-picker__cancel, ::v-deep .van-picker__confirm {
  font-size: 32px !important;
}
</style>
